import React from 'react';

/**
 * The panel every webhook configuration section is built from: an icon in a
 * bubble, a title, an optional line of explanation, and the section's own
 * controls beneath.
 *
 * Extracted because the layout had been hand-rolled twice and omitted entirely
 * four times, so a provider like GitHub showed a column of bare titled boxes
 * while Grain's credential card carried an icon. The bubble is what makes them
 * read as one family; the glyph inside says which section this is, so stacked
 * cards don't repeat the same provider logo down the screen.
 */
export const WebhookConfigCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
}> = ({ icon, title, description, children }) => (
  <div className="space-y-3 rounded-md border bg-muted/20 p-3">
    <div className="flex items-start gap-3">
      <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-background [&>svg]:h-4 [&>svg]:w-4 [&>svg]:text-muted-foreground">
        {icon}
      </div>
      <div className="min-w-0 space-y-1">
        <div className="text-sm font-medium">{title}</div>
        {description !== undefined && description !== null ? (
          <div className="text-muted-foreground text-xs">{description}</div>
        ) : null}
      </div>
    </div>
    {children}
  </div>
);
